import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLenis } from 'lenis/react';
import Lenis from 'lenis';

const ScrollArrow = ({ diffrentLenis }) => {
    const [showArrow, setShowArrow] = useState(false);

    const defaultLenis = useLenis();


    // Detect scroll position in Lenis
    useEffect(() => {
        const lenisToUse = diffrentLenis || defaultLenis;

        const handleLenisScroll = () => {
            // Accessing the current scroll position through Lenis instance
            const scrollTop = lenisToUse?.scroll;
            setShowArrow(scrollTop > 5);
        };

        // Listening for the Lenis scroll event
        lenisToUse?.on('scroll', handleLenisScroll);

        // Cleanup
        return () => {
            lenisToUse?.off('scroll', handleLenisScroll);
        };
    }, [defaultLenis, diffrentLenis]);

    const scrollToTop = () => {
       (diffrentLenis ? diffrentLenis : defaultLenis)?.scrollTo(0, {lerp:1.4});
    }

    return (
        <>
            <AnimatePresence mode='wait'>
                {showArrow && (
                    <motion.button
                        className="scroll-to-top fixed"
                        style={{ zIndex: diffrentLenis ? 10000 : 998 }}
                        onClick={scrollToTop}
                        initial={{ left: -60 }}
                        animate={{ left: 0 }}
                        exit={{ left: -60 }}
                        transition={{ duration: 0.2 }}
                    >
                        <svg onClick={scrollToTop} className="no-flip"  xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
                            <path d="M2.69607 15.266C-1.111 20.2266 9.81452 6.69324 12.099 1.83413C13.003 -0.0890605 21.0978 14.3934 24.6579 15.4752" stroke="black" strokeWidth="2.49634" strokeLinecap="round" />
                        </svg>
                    </motion.button>
                )}
            </AnimatePresence>
        </>
    );
};

export default ScrollArrow;
